import { useState } from "react";
import { LTabStrip } from "@loffa/gpp-modules";
import { AutoImportConfigurations } from "./AutoImportConfigurations/AutoImportConfigurations";
import { AutoimportLogs } from "./AutoimportLogs/AutoimportLogs";

function Automation() {
  const [selectedTab, setSelectedTab] = useState(0);
  
  return (
      <LTabStrip
        selected={selectedTab}
        onSelect={(e : any) => setSelectedTab(e.selected)}
        orientation="vertical"
        tabs={[
          {
            title: "Auto Import Configurations",
            body: <AutoImportConfigurations/>,
          },
          {
            title: "Auto Import Logs",
            body: <AutoimportLogs/>
          },
        ]}
        tabPosition="left"
      />
  );
}

export { Automation };
